// Admin (super admin) route guard component

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/sdk/auth/hooks';
import { NoFeatureAccess } from './NoFeatureAccess';
import { firstFeaturePath } from '../featurePaths';

interface AdminGuardProps {
  children: ReactNode;
}

/**
 * Component that checks if the current user is a super admin
 * Redirects to the first available feature if access is denied
 */
export function AdminGuard({ children }: AdminGuardProps) {
  const { user, currentOrg } = useAuth();

  if (!currentOrg) {
    return <Navigate to="/client/orgs" replace />;
  }

  if (!user?.is_super_admin) {
    // Redirect to the first available feature for non-admins
    const featurePath = firstFeaturePath(currentOrg.feature_access || []);
    if (!featurePath) {
      return <NoFeatureAccess orgName={currentOrg.name} reason="org" />;
    }

    // Redirect to first available feature
    return <Navigate to={`/dashboard/${currentOrg.id}/${featurePath}`} replace />;
  }

  return <>{children}</>;
}
